module.exports = __webpack_public_path__ + "static/media/silicon-farm-poster-tablet.483bf670.jpg";